import bbobHTML from '@bbob/html'
import presetHTML5 from '@bbob/preset-html5'

const replaceHtmlTags = (match) => {
  return match.replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

function removeEmptyTags (text) {
  const tags = ['b', 'i', 'u', 'center', 'left', 'right', 'justify', 'blockquote', 'color']
  let prev

  do {
    prev = text
    for (const tag of tags) {
      const regex = new RegExp(`\\[${tag}\\]\\s*\\[\\/${tag}\\]`, 'gi')
      text = text.replace(regex, '')
    }
  } while (text !== prev)

  return text
}

const convertEmptyPTags = (match) => {
  return match.replace(/\[p\]\[\/p\]/g, '<p></br></p>')
}

export default (bbcode, type) => {
  if (!bbcode) {
    return ''
  }
  const onlyAllowTags = [
    'b', 'i', 'u', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'list', '*', 'li', 'thead', 'table', 'tr', 'td', 'th', 'texticon', 'color', 'blockquote', 'center', 'right', 'left', 'justify', 'url', 'sup', 'sub', 'pill'
  ]

  bbcode = replaceHtmlTags(bbcode)
  bbcode = removeEmptyTags(bbcode)
  bbcode = convertEmptyPTags(bbcode)
  bbcode = bbcode.replace(/\n/g, '</br>')

  const typeLine = (node) => {
    const textAlignClasses = ['textalignleft', 'textaligncenter', 'textalignright', 'textalignjustify']
    let className = null

    textAlignClasses.forEach((textAlign) => {
      if (node.attrs[textAlign]) {
        className = textAlign
      }
    })

    return {
      tag: node.tag,
      attrs: className
        ? {
            class: className
          }
        : {},
      content: node.content
    }
  }

  if (bbcode && bbcode.length) {
    const preset = presetHTML5.extend((tags, options) => ({
      ...tags,
      b: node => ({
        tag: 'b',
        content: node.content
      }),
      u: node => ({
        tag: 'u',
        content: node.content
      }),
      i: node => ({
        tag: 'i',
        content: node.content
      }),
      list: (node) => {
        if (node.attrs.numberlist) {
          return {
            tag: 'ol',
            attrs: {
              class: 'numberlist'
            },
            content: node.content
          }
        } else if (node.attrs.bulletlist) {
          return {
            tag: 'ul',
            attrs: {
              class: 'bulletlist'
            },
            content: node.content
          }
        } else if (node.attrs.checklist) {
          return {
            tag: 'ul',
            attrs: {
              class: 'checklist'
            },
            content: node.content
          }
        } else if (node.attrs.checklistmedium) {
          return {
            tag: 'ul',
            attrs: {
              class: 'checklistmedium'
            },
            content: node.content
          }
        } else {
          return {
            tag: 'ul',
            content: node.content
          }
        }
      },
      table: (node) => {
        if (node.attrs && node.attrs.class && node.attrs.class === 'table') {
          return {
            tag: 'table',
            attrs: {
              class: 'table'
            },
            content: node.content
          }
        } else {
          return {
            tag: 'div',
            attrs: {
              class: 'table-container'
            },
            content: [{
              tag: 'table',
              attrs: {
                class: 'table'
              },
              content: node.content
            }]
          }
        }
      },
      blockquote: node => ({
        tag: 'blockquote',
        // attrs: {
        //   class: 'blockquote'
        // },
        content: node.content
      }),
      p: typeLine,
      li: typeLine,
      h1: typeLine,
      h2: typeLine,
      h3: typeLine,
      h4: typeLine,
      h5: typeLine,
      texticon: (node) => {
        if (Object.values(node.attrs)[0]) {
          return {
            tag: 'img',
            attrs: {
              class: 'texticon',
              loading: 'lazy',
              src: Object.values(node.attrs)[0]
            }
          }
        }
      },
      color: (node) => {
        if (Object.values(node.attrs)[0]) {
          return {
            // edytor -> font
            // client -> span
            tag: 'font',
            attrs: {
              color: Object.values(node.attrs)[0]
              // style: `color: ${Object.values(node.attrs)[0]}`
            },
            content: node.content
          }
        }
      },
      pill: (node) => {
        if (Object.values(node.attrs)[0]) {
          return {
            tag: 'pill',
            attrs: {
              class: Object.values(node.attrs)[0]
            },
            content: node.content
          }
        }
      }
    }))

    const options = {
      onlyAllowTags,
      enableEscapeTags: true
    }

    return bbobHTML(bbcode, preset(), options)
  } else {
    return ''
  }
}
